import React, { Component }  from 'react';
import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href=''
      className='link footer__link'
    >
      Created By Chiraphat Boonnag
    </a>
  </footer>
)

export default Footer
